import "./App.css";
import "./styles/main.css";
import "./styles/home.css";

import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import Intro from "./components/Intro/Intro";
// import Contact from "./components/ContactFloater";
import Contact from "./components/NewContact";

function App() {
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>Ramin Kahidi</title>
          <meta
            name="description"
            content="I'm Ramin Kahidi, and this is my personal portfolio displaying some of my past work."
          />
          <meta name="keywords" content="Ramin Kahidi, Portfolio, Past Work" />
        </Helmet>
        <main>
          {/* <div className="nav frost">
            <Navbar />
          </div> */}
          <div className="intro-background">
            <Intro />
          </div>

          {/* <About /> */}
          {/* <Personal /> */}
          {/* <PastWork /> */}
          <Contact />
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App;
